import React from 'react';
import { useSelector } from 'react-redux';

const arrowHeadPoints = '-1 -9 15 0 -1 9';

const FlowArrow = ({ flow }) => {
  const head = useSelector(
    state => state.document.present.arrowPositions.arrowHeads[flow],
  );
  const path = useSelector(
    state => state.document.present.arrowPositions.paths[flow],
  );
  return (
    <>
      {head && (
        <polygon
          className="canvas__flow_arrow_head"
          points={arrowHeadPoints}
          transform={`translate(${head.position.x} ${head.position.y}) rotate(${head.rotation})`}
        />
      )}
      <path className="canvas__flow_arrow_path_outer" d={path} />
      <path className="canvas__flow_arrow_path_inner" d={path} />
    </>
  );
};

export default React.memo(FlowArrow);
